import React, { Component } from 'react'
import { connect } from 'react-redux'
import RecurringPurchaseSample from '../samples/RecurringPurchaseSample'
import { makeRecurringPurchase } from '../../../actions/recurringActions'
import { updateOrderId } from '../../../actions/commonActions'
import { _RECURRING_BILLING } from '../../../actions/types'


export class RecurringPurchase extends Component {

    state = {
        showError:false,
        showSuccess:false,
        justClicked:false,
      };
    async generateOrderId() {
        const d = new Date();
        var orderId = "Test";
        orderId += d.getFullYear().toString();
        orderId += d.getMonth().toString();
        orderId += d.getDay().toString();
        orderId += d.getHours().toString();
        orderId += d.getMinutes().toString();
        orderId += d.getSeconds().toString();
        return orderId;
    }
 

    renderMessage() {
        if(this.state.showError) {
            return (
                <div style={{ marginTop:'-2vh', marginRight: '3vw',backgroundColor:'#ffcccc', color:'#cc0000', padding:'1vw', borderRadius:'10px', border:'1px solid #ff8080', lineHeight: '3vh'}}><strong>Error!</strong><br />Please check your parameters within recurring purchase.</div>
            );
        }
        // else if(this.state.showSuccess) {
        //     return (
        //         <div style={{ marginTop:'-2vh', marginRight: '3vw',backgroundColor:'#d6f5d6', color:'#196719', padding:'1vw', borderRadius:'10px', border:'1px solid #6fdc6f', lineHeight: '3vh'}}><strong>Recurring Purchase Accepted!</strong><br />The returned receipt has been inserted to the JSON on the right, you can make a Display Checkout Request now.</div>
        //     );
        // }
    }
    
    componentDidUpdate() {
        const { purchaseSuccess,purchaseResponse,loading } = this.props; 
        if(purchaseResponse!=="No request has been made."  && this.state.justClicked){
            if(purchaseSuccess){
                    this.setState({ showError: false,showSuccess: true,justClicked:false });  
                }
            else {
                if(!loading){
                    this.setState({  showError: true, showSuccess: false,justClicked:false });
                }
            }
        }
        }

    


    async onMakePurchasePress() {
        const newOrderId = await this.generateOrderId();
        this.props.updateOrderId({ featureId: _RECURRING_BILLING, orderId: newOrderId });
        const { storeId, apiToken, order_id, pan, expdate, amount } = this.props;
        const purchaseRequest = { storeId, apiToken, order_id, pan, expdate, amount };
        this.props.makeRecurringPurchase(purchaseRequest);
        this.setState({justClicked:true});
    }
 
    renderIntegrationTool() {
        return (
            <div className="stepMainContainer">
                <h3>Sample Purchase</h3>
                <RecurringPurchaseSample />
                <div className="requestButton" onClick={() => this.onMakePurchasePress()}>
                    Purchase Request
                </div> 
                {this.renderMessage()}
            </div>
        );
    }
    
    renderDocument() {
    const { progLangId } = this.props;    
    return (
    <div className="stepPageContainer">  
        <div>
        <h3 className="stepPageTitle">Purchase with Recurring Billing</h3>
        <p><b>Recurring Billing Info Object Definition</b></p>   

        {(() => {
                switch(progLangId) {
                    case 0:
                        console.log(progLangId)
                        return <code>Recur recurring_cycle = new Recur(recur_unit, start_now, start_date, num_
                            recurs, period, recur_amount);</code>
                    case 1:
                        console.log(progLangId)
                        return <code>Recur recurring_cycle = new Recur(recur_unit, start_now, start_date, num_
                            recurs, period, recur_amount);</code>
                    case 2:
                        console.log(progLangId)
                        return <code>
                            {`$recurArray = array(`}<br/>
                            {`'recur_unit'=>$recurUnit, // (day | week | month)`}<br/>
                            {`'start_date'=>$startDate, //yyyy/mm/dd`}<br/>
                            {`'num_recurs'=>$numRecurs,`}<br/>
                            {`'start_now'=>$startNow,`}<br/>
                            {`'period' => $recurInterval,`}<br/>
                            {`'recur_amount'=> $recurAmount);`}<br/>
                            {`$mpgRecur = new mpgRecur($recurArray);`}
                            </code>
                    default:
                        return null
                    }
                })()}

        <p><b>Transaction object set method</b></p>   
        {(() => {
                switch(progLangId) {
                    case 0:
                        return <code>{`<transaction>`}.SetRecur(recurring_cycle);</code>
                    case 1:
                        return <code>{`<transaction>`}.SetRecur(recurring_cycle);</code>
                    case 2:
                        return <code>{`$mpgTxn->setRecur($mpgRecur);`} </code>
                    default:
                        return null
                    }
                })()}


    <h3 className="stepPageTitle" style={{ fontSize:"1.2vw",marginTop:"7vh"}}>Recurring Billing Info Object Request Fields</h3>
        <table style={{maxWidth:"100%", width:"100%"}}>
        <tbody>
            <tr>
                
                <th>Variable Name</th>
                <th>Type</th>
                <th>Description</th>
            </tr>
            <tr>
                <td>number of recurs</td>
                <td>String<br/>numeric<br/>1-999</td>
                <td>The number of times that the transaction must recur</td>
            </tr>
            <tr>
                <td>period<br /></td>
                <td>String<br/>numeric<br/>1-999</td>
                <td>Number of recur unit intervals that must pass between recurring billings</td>
            </tr>
            <tr>
                <td>start date<br /></td>
                <td>String<br/>YYMMDD format</td>
                <td>Date of the first future recurring billing
                    transaction; this must be a date in the
                    future
                    <br/>
                    If an additional charge will be made
                    immediately, the start now variable
                    must be set to true
                </td>
            </tr>
            <tr>
                <td>start now</td>
                <td>String<br/>true/false</td>
                <td>Set to true if a charge will be made
                    against the card immediately; otherwise
                    set to false
                    <br/>
                    When set to false, use Card Verification
                    prior to sending the Purchase
                    with Recurring Billing and Credential
                    on File objects
                    <br/>
                        <p className="note">
                            <strong>NOTE: </strong> 
                            Amount to be billed immediately
                            can differ from the subsequent recurring
                            amounts       
                        </p>
                </td>
            </tr>
            <tr>
                <td>recurring amount<br /></td>
                <td>
                    String<br/>
                    10-character decimal, minimum three digits<br/>
                    Up to 7 digits (dollars) +
                    decimal point (.) + 2 digits
                    (cents) after the decimal
                    point<br/>
                        <p className="note">
                            <strong>NOTE: </strong> 
                            Amount to be billed immediately
                            can differ from the subsequent recurring
                            amounts       
                        </p>
                </td>
                <td>Dollar amount of the recurring transaction<br/>
                    This amount will be billed on the start
                    date, and then billed repeatedly based
                    on the interval defined by period and
                    recur unit
                </td>
            </tr>
            <tr>
                <td>recur unit<br /></td>
                <td>
                    String<br/>day, week, month or eom
                </td>
                <td>
                    Unit to be used as a basis for the intervel<br/>
                    Works in conjunction with the period variable to define the billing frequency
                </td>
            </tr>
            </tbody>
        </table>


          <p>
            
          You can modify a Recurring Billing series after it has been created by sending the Recurring Billing Update administrative transaction.
          </p>
              <p className="note">
                <strong>NOTE: </strong> 
                Alternatively, if you prefer to manage recurring series on your own merchant system,
                you can send the periodic payments as basic Purchase transactions with the e-commerce
                indicator (<code>crypt_type</code>) value = 2 and with the Credential on File info object
                included.         
              </p>
        
      </div>
    </div>
    )
    }

    render() {
        const { mode } = this.props;
        if(mode === 'interactive_tool')
            return this.renderIntegrationTool();
        else if(mode === 'integration_guide')
            return this.renderDocument();
        else {
            return null;
        }
    }
}

const mapStateToProps = state => {
    const { mode } = state.common.sideNav;
    const { purchaseSuccess,purchaseResponse,loading } = state.recurring.main;
    const { storeId, apiToken, order_id, pan, expdate, amount} = state.recurring.main.config;
    return { mode, storeId, apiToken, order_id, pan, expdate, amount,loading, progLangId: state.common.progLangList.selection,purchaseSuccess,purchaseResponse };
  }

  export default connect(mapStateToProps, {makeRecurringPurchase, updateOrderId})(RecurringPurchase)

